'use client';
/** @jsxImportSource @emotion/react */

import { forwardRef } from 'react';

import type { RatingProps as MuiRatingProps } from '@mui/material/Rating';

import MuiRating from '@mui/material/Rating';

type ExcludedMuiProps = 'highlightSelectedOnly' | 'readOnly';

interface RatingProps extends Omit<MuiRatingProps, ExcludedMuiProps> {
  component?: React.ElementType;
  /**
   * Removes all hover effects and pointer events.
   * @default true
   */
  readOnly?: boolean;
}

const Rating = forwardRef<HTMLSpanElement, RatingProps>(
  ({ readOnly = true, ...props }, ref) => {
    return <MuiRating ref={ref} readOnly={readOnly} {...props} />;
  }
);

Rating.displayName = 'Rating';

export { Rating, type RatingProps };
